module.exports = __webpack_public_path__ + "img/icon_element_hover.a9cc6d9b.svg";